/** Feedback: for a visitor with an opinion. Layout lives in `FormPage`. */
import { HUBSPOT } from "../demo";
import { FormPage } from "./FormPage";
import type { AsideItem } from "./FormPage";

const USEFUL: AsideItem[] = [
  {
    icon: "crop_free",
    text: "A region boxed around the wrong thing, or a value filed under the wrong drawing.",
  },
  {
    icon: "rule",
    text: "A dimension, tolerance or table row read incorrectly - tell us which sheet and where.",
  },
  {
    icon: "lightbulb",
    text: "Something you expected to be able to do and could not find.",
  },
];

export function Feedback() {
  return (
    <FormPage
      title="Leave feedback"
      caption="This is a demo and it is still being shaped. What did it get wrong, and what was missing?"
      formId={HUBSPOT.forms.feedback}
      asideTitle="Especially useful"
      aside={USEFUL}
    />
  );
}
